export function graphMinZoom(
  bounds: { width: number; height: number },
  size: { width: number; height: number }
) {
  return Math.min(
    0.35,
    size.width / Math.max(1, bounds.width * 1.4),
    size.height / Math.max(1, bounds.height * 1.4)
  );
}
